import type { FunctionComponent } from 'react';
import { Suspense } from 'react';
import { useIntl } from 'react-intl';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import type { PopoverProps } from '@trello/nachos/popover';
import { Popover } from '@trello/nachos/popover';
import { useLazyComponent } from '@trello/use-lazy-component';

interface LazyMirrorCardPopoverProps {
  popoverProps?: PopoverProps;
  hide: () => void;
}
export const LazyMirrorCardPopover: FunctionComponent<
  LazyMirrorCardPopoverProps
> = ({ popoverProps, hide }) => {
  const intl = useIntl();

  const MirrorCardPopover = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "mirror-card-popover" */ './MirrorCardPopover'
      ),
    { namedImport: 'MirrorCardPopover' },
  );

  const contents = (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null}>
        <MirrorCardPopover hide={hide} />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );

  if (!popoverProps) {
    return contents;
  }

  return (
    <Popover
      title={intl.formatMessage({
        id: 'templates.popover_mirror_card.mirror-card',
        defaultMessage: 'Mirror card',
        description: 'Title for the mirror card popover',
      })}
      {...popoverProps}
    >
      {contents}
    </Popover>
  );
};
